import { render } from "./PriceView.vue?vue&type=template&id=e0dce44c"
import script from "./PriceView.vue?vue&type=script&lang=js"
export * from "./PriceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__